module.exports = require("nest-winston");